export const blogPosts = [
  {
    id: 1,
    slug: "kuwait-real-estate-guide-2026",
    title: "دليلك الشامل لشراء عقار في الكويت 2026",
    excerpt:
      "كل ما تحتاج معرفته عن الإجراءات القانونية، التمويل، وأفضل المناطق للاستثمار.",
    category: "دليل المشتري",
    date: "2026-03-15",
    readTime: "8 دقائق",
    image: require("@/assets/media/4.png"),
    author: "فهد العتيبي",
    content: `
      <p>شراء عقار في الكويت قرار استثماري كبير يتطلب فهماً دقيقاً للسوق المحلي والإجراءات القانونية.</p>
      <h3>الخطوات الأساسية</h3>
      <p>ابدأ بتحديد ميزانيتك واحصل على موافقة مبدئية من البنك. ثم حدّد المنطقة المناسبة لنمط حياتك — السالمية للبحر، الأحمدي للهدوء، الشرق للعمل.</p>
      <h3>المستندات المطلوبة</h3>
      <p>بطاقة مدنية سارية، شهادة راتب أو كشف حساب، وموافقة البنك إن وُجد تمويل. للمقيمين: إقامة سارية وموافقة الجهات المختصة.</p>
      <h3>نصائح ذهبية</h3>
      <p>لا تتسرع — قارن 5 عقارات على الأقل، افحص البنية التحتية، واستعن بوسيط موثوق لتفادي المفاجآت.</p>
    `,
  },
  {
    id: 2,
    slug: "best-areas-for-families",
    title: "أفضل 5 مناطق للعائلات في الكويت",
    excerpt:
      "مقارنة بين السالمية، الأحمدي، حولي، والفروانية من حيث المدارس والأمان والأسعار.",
    category: "مناطق",
    date: "2026-02-28",
    readTime: "6 دقائق",
    image: require("@/assets/media/4.png"),
    author: "نورة الصباح",
    content: `
      <p>اختيار الحي المناسب يؤثر على جودة حياة عائلتك لسنوات. إليك مقارنة موضوعية.</p>
      <h3>1. السالمية</h3>
      <p>مثالية للعائلات التي تحب البحر والمدارس الدولية. أسعار أعلى لكن بنية تحتية ممتازة.</p>
      <h3>2. الأحمدي</h3>
      <p>فيلات واسعة ومجتمعات هادئة. الأفضل للعائلات الكبيرة.</p>
      <h3>3. حولي</h3>
      <p>موقع مركزي — قريب من كل شيء. مناسب لمن يعمل في العاصمة.</p>
    `,
  },
  {
    id: 3,
    slug: "rent-vs-buy-kuwait",
    title: "إيجار أم شراء؟ تحليل واقعي للسوق الكويتي",
    excerpt:
      "متى يكون الإيجار الخيار الأذكى ومتى يستحق الشراء — أرقام ومعادلات بسيطة.",
    category: "استثمار",
    date: "2026-02-10",
    readTime: "7 دقائق",
    image: require("@/assets/media/3.png"),
    author: "محمد الرشيد",
    content: `
      <p>السؤال الأ eternal: هل أستأجر أم أشتري؟ الجواب يعتمد على ظروفك المالية وأهدافك.</p>
      <h3>متى الإيجار؟</h3>
      <p>إذا كنت جديداً في الكويت، أو تتوقع انتقالاً خلال 2–3 سنوات، أو تفضل مرونة مالية — الإيجار منطقي.</p>
      <h3>متى الشراء؟</h3>
      <p>استقرار 5+ سنوات، دفعة أولى متوفرة، وأسعار فائدة مناسبة — الشراء استثمار طويل الأمد.</p>
    `,
  },
  {
    id: 4,
    slug: "home-staging-tips",
    title: "7 نصائح لتجهيز منزلك للبيع بسرعة",
    excerpt:
      "كيف تزيد قيمة عقارك وتقلّل وقت البقاء في السوق — tricks بسيطة بأثر كبير.",
    category: "نصائح",
    date: "2026-01-22",
    readTime: "5 دقائق",
    image: require("@/assets/media/4.png"),
    author: "سارة المطيري",
    content: `
      <p>أول انطباع يُ sold المنزل. إليك كيف تحقق أقصى impact بأقل budget.</p>
      <h3>1. Declutter</h3>
      <p>أزل 30% من الأثاث — المساحات الفارغة تبدو أكبر.</p>
      <h3>2. إضاءة</h3>
      <p>افتح الستائر، نظّف النوافذ، أضف مصابيح warm في الزوايا المظلمة.</p>
    `,
  },
];

export function getBlogBySlug(slug) {
  return blogPosts.find((p) => p.slug === slug);
}
